// This icon file is generated automatically.
var PCarryOutOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.75 1.88h-2.63v-1A.13.13 0 0010 .74h-.88A.13.13 0 009 .88v1H5v-1a.13.13 0 00-.13-.13H4a.13.13 0 00-.13.13v1H1.25a.5.5 0 00-.5.5v10.37c0 .28.22.5.5.5h11.5a.5.5 0 00.5-.5V2.37a.5.5 0 00-.5-.5zm-.63 10.25H1.88V3h2v.75c0 .07.05.13.12.13h.88c.06 0 .12-.06.12-.13V3h4v.75c0 .07.06.13.13.13H10c.07 0 .13-.06.13-.13V3h2v9.13zM9.75 5.55h-.86a.25.25 0 00-.2.1L6.32 8.92 5.32 7.52a.25.25 0 00-.2-.1h-.87c-.1 0-.16.11-.1.2l1.97 2.72c.1.13.31.13.41 0l3.32-4.58c.06-.08 0-.2-.1-.2z", "fill-rule": "nonzero" } }] }, "name": "p-carry-out", "theme": "outlined" };
export default PCarryOutOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PCarryOutOutlined.js
// module id = 3279
// module chunks = 0